<template>
    <div v-show="visible">
        <el-dialog title="导出配置" :close-on-click-modal="false" :visible.sync="visible" 
            v-loading="loading"
            :element-loading-text="loadingText"
            element-loading-spinner="el-icon-loading"
            :before-close="dialogClose" width="450px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                     
                <el-form-item   prop="scoreType" label="排序方式：">
                    <el-select v-model="form.sortType" style="width:150px;">
                        <el-option
                            v-for="item in scoreTypes"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item   prop="scoreType" label="得分计算：">
                    <el-select v-model="form.scoreCalculation" @change="changeScoreCalculation" style="width:150px;">
                        <el-option
                            v-for="item in scoreCalculations"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <span v-if="showScoreCalculationTip">
                    ，按&nbsp;<el-input v-model="form.avg" max="99" min="1" type="number" style="width:80px;"></el-input>
                    &nbsp;{{form.avgDescription}}
                    </span>
                </el-form-item>
            </el-form>
            <div style="color:red;font-size: 12px;">注：平均分导出时，请确认起止时间的跨度为整周或整月。也可手工调整周月数</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">关闭</el-button>
                <el-button type="primary" @click="save()">确定导出</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import axios from 'axios';
    import http from '../../../../common/http';

    export default {
        data(){
            return{
                visible: false,
                loading:false,
                loadingText:"",
                showScoreCalculationTip: false,
                form:{
                    id:"",
                    title:"",
                    startDate:"",
                    endDate:"",
                    sortType:"", // 排序方式-sortType(总分-1、年级班级-2)。
                    scoreCalculation:"", // 得分计算-scoreCalculation(总分-1、平均分(每月/每周)-2)。
                    avg:"",
                    avgDescription:""
                },
                rules: {
                },
                scoreTypes:[
                    {
                        'value':1,
                        'label':'总分'
                    },{
                        'value':2,
                        'label':'年级班级'
                    },{
                        'value':3,
                        'label':'年级班级总分'
                    }
                ],
                scoreCalculations:[
                    {
                        'value':1,
                        'label':'总分'
                    },{
                        'value':2,
                        'label':'平均分(每月/每周)'
                    }
                ],
            }
        },
        created:function () {
        },
        methods:{
            init(data,startDate,endDate){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                // 初始值
                this.form.sortType = 1;
                this.form.scoreCalculation = 1;
                this.showScoreCalculationTip = false;

                // 开始日期
                this.form.startDate = startDate;
                // 结束日期
                this.form.endDate = endDate;
                this.form.id = data.id;
                this.form.title = data.title;

                console.log("id="+data.id);
                console.log("title="+data.title);

            },
            dialogClose(done){
                done();
                this.$reload;
            },
            // 得分计算触发事件
            changeScoreCalculation(){
                let val = this.form.scoreCalculation;
                if( val == 2){
                    this.showScoreCalculationTip=true;
                    this.getWeeksOrMonths();
                }else{
                    this.showScoreCalculationTip=false;
                    this.form.avg = 0;
                }
            },
            //通过开始日期-结束日期，获取月数或者周数
            getWeeksOrMonths(){
                let url  = this.evaluateDetailExportWeekOrMonthCountUrl;
                let data = {
                    startDate:this.form.startDate,
                    endDate:this.form.endDate,
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status == 200){
                        if(res.data.avg < 1){
                            this.form.avg = 1;
                        }else{
                            this.form.avg = res.data.avg;
                        }
                      
                        this.form.avgDescription = res.data.avgDescription;
                        console.log("avg="+this.form.avg+"，avgDescription="+this.form.avgDescription);
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            save(){
                // 得分计算选择平均分，平均值必须填写
                if(this.form.scoreCalculation == 2){
                    if(this.form.avg <1){
                        this.$commonFn.showTip("平均分不能小于1",3);
                        return;
                    }
                }

                this.loading=true;
                this.loadingText="正在导出中，导出过程时间可能会比较长，请耐心等待";

                let url=this.evaluateDetailArchiveExportUrl;
                let param = new URLSearchParams();
                param.append('id', this.form.id);
                param.append('startDate', this.form.startDate);
                param.append('endDate', this.form.endDate);
                // 排序方式-sortType(总分-1、年级班级-2)。
                param.append('sortType',this.form.sortType);
                // 得分计算-scoreCalculation(总分-1、平均分(每月/每周)-2)。
                param.append('scoreCalculation',this.form.scoreCalculation);
                param.append('avg',this.form.avg);
                
                let reg=new RegExp('-','g')
                let startDate=this.form.startDate.replace(reg,'.');
                let endDate=this.form.endDate.replace(reg,'.');
                let fileName=this.form.title+"("+startDate+"-"+endDate+")";

                axios({
                    method: "post",
                    url: url,
                    data: param,
                    responseType: "blob"
                }).then(res => {
                    const link = document.createElement("a");
                    let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
                    link.style.display = "none";
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute("download", fileName+'.xls');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.loading=false;
                }).catch(error => {
                    console.log(error);
                    this.loading=false;
                });

            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/evaluateArchive/ClassEvaluateExprot.vue